import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';
import {
  FETCH_BANNER_ANNOUNCEMENT_FAILURE,
  FETCH_BANNER_ANNOUNCEMENT_SUCCESS,
} from '../../../settings/containers/announcements/constants';

export const isLoggedIn = handleActions(
  {
    [actionTypes.USER_REQUEST]: () => false,
    [actionTypes.USER_SUCCESS]: () => true,
    [actionTypes.USER_FAILURE]: () => false,
  },
  false,
);

export const fullname = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => action.payload.fullName || 'unknown',
  },
  '',
);

export const id = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => action.payload.id,
  },
  '',
);

export const serviceCenters = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => action.payload.serviceCenters || [],
  },
  [],
);

export const brand = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => action.payload.brand,
  },
  '',
);

export const defaultServiceCenter = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => action.payload.defaultServiceCenter,
  },
  '',
);

export const adminFor = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => action.payload.adminFor || [],
  },
  [],
);

export const plannerGroups = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => action.payload.plannerGroups,
  },
  [],
);

export const permissions = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => ({
      ...action.payload.permissions,
      alwaysTrue: true,
    }),
    [actionTypes.USER_FAILURE]: () => ({ alwaysTrue: true }),
  },
  { alwaysTrue: true },
);

export const features = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => ({
      ...action.payload.features,
      alwaysTrue: true,
      createTicket: true,
      tickets: true,
    }),
    [actionTypes.USER_FAILURE]: () => ({ alwaysTrue: true }),
  },
  { alwaysTrue: true },
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.USER_REQUEST,
      actionTypes.USER_SUCCESS,
    )]: () => ({}),
    [actionTypes.USER_FAILURE]: (state, { payload }) =>
    ({
      ...payload.error,
      isNotAuthorized: true,
    }),
  },
  {},
);

export const username = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, action) => action.payload.username,
  },
  '',
);

export const hasAnnouncementBanner = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, { payload }) => !!payload?.bannerAnnouncement,
    [FETCH_BANNER_ANNOUNCEMENT_SUCCESS]: (state, { payload }) => !!payload?.bannerAnnouncement,
    [FETCH_BANNER_ANNOUNCEMENT_FAILURE]: () => false,
  },
  false,
);

export const bannerAnnouncement = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, { payload }) => payload?.bannerAnnouncement,
    [FETCH_BANNER_ANNOUNCEMENT_SUCCESS]: (state, { payload }) => payload?.bannerAnnouncement,
    [FETCH_BANNER_ANNOUNCEMENT_FAILURE]: () => ({}),
  },
  {},
);

export const mapProvider = handleActions(
  {
    [actionTypes.USER_SUCCESS]: (state, { payload }) => payload?.geoProvider,
  },
  '',
);

export default combineReducers({
  isLoggedIn,
  fullname,
  id,
  serviceCenters,
  brand,
  defaultServiceCenter,
  error,
  features,
  username,
  adminFor,
  permissions,
  hasAnnouncementBanner,
  bannerAnnouncement,
  mapProvider,
  plannerGroups,
});
